// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { AddressMode } from "./address-mode";
import { Decode, unionToDecode, unionListToDecode } from "./decode";
import { EnumMapRule, EnumMapRuleT, verifyEnumMapRule } from "./enum-map-rule";
import { Expansion } from "./expansion";
import { FlagRule, FlagRuleT, verifyFlagRule } from "./flag-rule";
import { IgnoreRule, IgnoreRuleT, verifyIgnoreRule } from "./ignore-rule";
import { Key, KeyT } from "./key";
import { Origin } from "./origin";
import { RecordRule, RecordRuleT, verifyRecordRule } from "./record-rule";
import { Rule, unionToRule, unionListToRule } from "./rule";
import { ScalarDecode, ScalarDecodeT, verifyScalarDecode } from "./scalar-decode";
import { SourceFile } from "./source-file";
import { StructDecode, StructDecodeT, verifyStructDecode } from "./struct-decode";
import { TextDecode, TextDecodeT, verifyTextDecode } from "./text-decode";
import { TransformDecode, TransformDecodeT, verifyTransformDecode } from "./transform-decode";
import { TransformRule, TransformRuleT, verifyTransformRule } from "./transform-rule";
import { ValuedRule, ValuedRuleT, verifyValuedRule } from "./valued-rule";

/**
 * One IDL declaration, the base of an array, and its translation.
 */
export class Entry implements flatbuffers.IUnpackableObject<EntryT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): Entry {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsEntry(bb: flatbuffers.ByteBuffer, obj?: Entry): Entry {
    return (obj || new Entry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsEntry(bb: flatbuffers.ByteBuffer, obj?: Entry): Entry {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new Entry()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  key(obj?: Key): Key | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? (obj || new Key()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  name(): string;
  name(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  name(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  dataType(): string;
  dataType(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  dataType(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  parentCategory(): string | null;
  parentCategory(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  parentCategory(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  arrayLen(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  arrayLenExpr(): string | null;
  arrayLenExpr(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  arrayLenExpr(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  expansion(): Expansion {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Expansion.None;
  }

  addedVersion(): string | null;
  addedVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  addedVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  obsolete(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  notImplemented(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 22);
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
  }

  source(): SourceFile {
    const offset = this.bb!.__offset(this.bb_pos, 24);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : SourceFile.None;
  }

  includeIndex(): number {
    const offset = this.bb!.__offset(this.bb_pos, 26);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  line(): number {
    const offset = this.bb!.__offset(this.bb_pos, 28);
    return offset ? this.bb!.readUint32(this.bb_pos + offset) : 0;
  }

  decodeType(): Decode {
    const offset = this.bb!.__offset(this.bb_pos, 30);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Decode.NONE;
  }

  decode<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 32);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  ruleType(): Rule {
    const offset = this.bb!.__offset(this.bb_pos, 34);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Rule.NONE;
  }

  rule<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 36);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  address(): AddressMode {
    const offset = this.bb!.__offset(this.bb_pos, 38);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : AddressMode.Unspecified;
  }

  addressField(): string | null;
  addressField(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  addressField(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 40);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  origin(): Origin {
    const offset = this.bb!.__offset(this.bb_pos, 42);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : Origin.Unmapped;
  }

  profileRow(): string | null;
  profileRow(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  profileRow(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 44);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startEntry(builder: flatbuffers.Builder) {
    builder.startObject(21);
  }

  static addKey(builder: flatbuffers.Builder, keyOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, keyOffset, 0);
  }

  static addName(builder: flatbuffers.Builder, nameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, nameOffset, 0);
  }

  static addDataType(builder: flatbuffers.Builder, dataTypeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, dataTypeOffset, 0);
  }

  static addParentCategory(builder: flatbuffers.Builder, parentCategoryOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, parentCategoryOffset, 0);
  }

  static addArrayLen(builder: flatbuffers.Builder, arrayLen: number) {
    builder.addFieldInt16(4, arrayLen, 0);
  }

  static addArrayLenExpr(builder: flatbuffers.Builder, arrayLenExprOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, arrayLenExprOffset, 0);
  }

  static addExpansion(builder: flatbuffers.Builder, expansion: Expansion) {
    builder.addFieldInt8(6, expansion, Expansion.None);
  }

  static addAddedVersion(builder: flatbuffers.Builder, addedVersionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(7, addedVersionOffset, 0);
  }

  static addObsolete(builder: flatbuffers.Builder, obsolete: boolean) {
    builder.addFieldInt8(8, +obsolete, +false);
  }

  static addNotImplemented(builder: flatbuffers.Builder, notImplemented: boolean) {
    builder.addFieldInt8(9, +notImplemented, +false);
  }

  static addSource(builder: flatbuffers.Builder, source: SourceFile) {
    builder.addFieldInt8(10, source, SourceFile.None);
  }

  static addIncludeIndex(builder: flatbuffers.Builder, includeIndex: number) {
    builder.addFieldInt16(11, includeIndex, 0);
  }

  static addLine(builder: flatbuffers.Builder, line: number) {
    builder.addFieldInt32(12, line, 0);
  }

  static addDecodeType(builder: flatbuffers.Builder, decodeType: Decode) {
    builder.addFieldInt8(13, decodeType, Decode.NONE);
  }

  static addDecode(builder: flatbuffers.Builder, decodeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(14, decodeOffset, 0);
  }

  static addRuleType(builder: flatbuffers.Builder, ruleType: Rule) {
    builder.addFieldInt8(15, ruleType, Rule.NONE);
  }

  static addRule(builder: flatbuffers.Builder, ruleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(16, ruleOffset, 0);
  }

  static addAddress(builder: flatbuffers.Builder, address: AddressMode) {
    builder.addFieldInt8(17, address, AddressMode.Unspecified);
  }

  static addAddressField(builder: flatbuffers.Builder, addressFieldOffset: flatbuffers.Offset) {
    builder.addFieldOffset(18, addressFieldOffset, 0);
  }

  static addOrigin(builder: flatbuffers.Builder, origin: Origin) {
    builder.addFieldInt8(19, origin, Origin.Unmapped);
  }

  static addProfileRow(builder: flatbuffers.Builder, profileRowOffset: flatbuffers.Offset) {
    builder.addFieldOffset(20, profileRowOffset, 0);
  }

  static endEntry(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // key
    builder.requiredField(offset, 6); // name
    builder.requiredField(offset, 8); // data_type
    builder.requiredField(offset, 36); // rule
    return offset;
  }

  static createEntry(
    builder: flatbuffers.Builder,
    keyOffset: flatbuffers.Offset,
    nameOffset: flatbuffers.Offset,
    dataTypeOffset: flatbuffers.Offset,
    parentCategoryOffset: flatbuffers.Offset,
    arrayLen: number,
    arrayLenExprOffset: flatbuffers.Offset,
    expansion: Expansion,
    addedVersionOffset: flatbuffers.Offset,
    obsolete: boolean,
    notImplemented: boolean,
    source: SourceFile,
    includeIndex: number,
    line: number,
    decodeType: Decode,
    decodeOffset: flatbuffers.Offset,
    ruleType: Rule,
    ruleOffset: flatbuffers.Offset,
    address: AddressMode,
    addressFieldOffset: flatbuffers.Offset,
    origin: Origin,
    profileRowOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    Entry.startEntry(builder);
    Entry.addKey(builder, keyOffset);
    Entry.addName(builder, nameOffset);
    Entry.addDataType(builder, dataTypeOffset);
    Entry.addParentCategory(builder, parentCategoryOffset);
    Entry.addArrayLen(builder, arrayLen);
    Entry.addArrayLenExpr(builder, arrayLenExprOffset);
    Entry.addExpansion(builder, expansion);
    Entry.addAddedVersion(builder, addedVersionOffset);
    Entry.addObsolete(builder, obsolete);
    Entry.addNotImplemented(builder, notImplemented);
    Entry.addSource(builder, source);
    Entry.addIncludeIndex(builder, includeIndex);
    Entry.addLine(builder, line);
    Entry.addDecodeType(builder, decodeType);
    Entry.addDecode(builder, decodeOffset);
    Entry.addRuleType(builder, ruleType);
    Entry.addRule(builder, ruleOffset);
    Entry.addAddress(builder, address);
    Entry.addAddressField(builder, addressFieldOffset);
    Entry.addOrigin(builder, origin);
    Entry.addProfileRow(builder, profileRowOffset);
    return Entry.endEntry(builder);
  }

  unpack(): EntryT {
    return new EntryT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.name(),
      this.dataType(),
      this.parentCategory(),
      this.arrayLen(),
      this.arrayLenExpr(),
      this.expansion(),
      this.addedVersion(),
      this.obsolete(),
      this.notImplemented(),
      this.source(),
      this.includeIndex(),
      this.line(),
      this.decodeType(),
      (() => {
        const temp = unionToDecode(this.decodeType(), this.decode.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.ruleType(),
      (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.address(),
      this.addressField(),
      this.origin(),
      this.profileRow(),
    );
  }

  unpackTo(_o: EntryT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.name = this.name();
    _o.dataType = this.dataType();
    _o.parentCategory = this.parentCategory();
    _o.arrayLen = this.arrayLen();
    _o.arrayLenExpr = this.arrayLenExpr();
    _o.expansion = this.expansion();
    _o.addedVersion = this.addedVersion();
    _o.obsolete = this.obsolete();
    _o.notImplemented = this.notImplemented();
    _o.source = this.source();
    _o.includeIndex = this.includeIndex();
    _o.line = this.line();
    _o.decodeType = this.decodeType();
    _o.decode = (() => {
      const temp = unionToDecode(this.decodeType(), this.decode.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.ruleType = this.ruleType();
    _o.rule = (() => {
      const temp = unionToRule(this.ruleType(), this.rule.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.address = this.address();
    _o.addressField = this.addressField();
    _o.origin = this.origin();
    _o.profileRow = this.profileRow();
  }

  unpackFields(...fields: string[]): EntryT {
    const t = new EntryT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("key")) {
      t.key = this.key() !== null ? this.key()!.unpack() : null;
    }
    if (fieldSet.has("name")) {
      t.name = this.name();
    }
    if (fieldSet.has("data_type")) {
      t.dataType = this.dataType();
    }
    if (fieldSet.has("parent_category")) {
      t.parentCategory = this.parentCategory();
    }
    if (fieldSet.has("array_len")) {
      t.arrayLen = this.arrayLen();
    }
    if (fieldSet.has("array_len_expr")) {
      t.arrayLenExpr = this.arrayLenExpr();
    }
    if (fieldSet.has("expansion")) {
      t.expansion = this.expansion();
    }
    if (fieldSet.has("added_version")) {
      t.addedVersion = this.addedVersion();
    }
    if (fieldSet.has("obsolete")) {
      t.obsolete = this.obsolete();
    }
    if (fieldSet.has("not_implemented")) {
      t.notImplemented = this.notImplemented();
    }
    if (fieldSet.has("source")) {
      t.source = this.source();
    }
    if (fieldSet.has("include_index")) {
      t.includeIndex = this.includeIndex();
    }
    if (fieldSet.has("line")) {
      t.line = this.line();
    }
    if (fieldSet.has("decode_type")) {
      t.decodeType = this.decodeType();
    }
    if (fieldSet.has("decode")) {
      t.decode = (() => {
        const temp = unionToDecode(this.decodeType(), this.decode.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("rule_type")) {
      t.ruleType = this.ruleType();
    }
    if (fieldSet.has("rule")) {
      t.rule = (() => {
        const temp = unionToRule(this.ruleType(), this.rule.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("address")) {
      t.address = this.address();
    }
    if (fieldSet.has("address_field")) {
      t.addressField = this.addressField();
    }
    if (fieldSet.has("origin")) {
      t.origin = this.origin();
    }
    if (fieldSet.has("profile_row")) {
      t.profileRow = this.profileRow();
    }
    return t;
  }
}

export class EntryT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: KeyT | null = null,
    public name: string | Uint8Array | null = null,
    public dataType: string | Uint8Array | null = null,
    public parentCategory: string | Uint8Array | null = null,
    public arrayLen: number = 0,
    public arrayLenExpr: string | Uint8Array | null = null,
    public expansion: Expansion = Expansion.None,
    public addedVersion: string | Uint8Array | null = null,
    public obsolete: boolean = false,
    public notImplemented: boolean = false,
    public source: SourceFile = SourceFile.None,
    public includeIndex: number = 0,
    public line: number = 0,
    public decodeType: Decode = Decode.NONE,
    public decode: ScalarDecodeT | StructDecodeT | TextDecodeT | TransformDecodeT | null = null,
    public ruleType: Rule = Rule.NONE,
    public rule:
      | EnumMapRuleT
      | FlagRuleT
      | IgnoreRuleT
      | RecordRuleT
      | TransformRuleT
      | ValuedRuleT
      | null = null,
    public address: AddressMode = AddressMode.Unspecified,
    public addressField: string | Uint8Array | null = null,
    public origin: Origin = Origin.Unmapped,
    public profileRow: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.key === null || this.key === undefined) {
      throw new Error('Required field "key" is not set');
    }
    if (this.name === null || this.name === undefined) {
      throw new Error('Required field "name" is not set');
    }
    if (this.dataType === null || this.dataType === undefined) {
      throw new Error('Required field "data_type" is not set');
    }
    if (this.rule === null || this.rule === undefined) {
      throw new Error('Required field "rule" is not set');
    }
    const name = this.name !== null ? builder.createString(this.name!) : 0;
    const dataType = this.dataType !== null ? builder.createString(this.dataType!) : 0;
    const parentCategory =
      this.parentCategory !== null ? builder.createString(this.parentCategory!) : 0;
    const arrayLenExpr = this.arrayLenExpr !== null ? builder.createString(this.arrayLenExpr!) : 0;
    const addedVersion = this.addedVersion !== null ? builder.createString(this.addedVersion!) : 0;
    const decode = builder.createObjectOffset(this.decode);
    const rule = builder.createObjectOffset(this.rule);
    const addressField = this.addressField !== null ? builder.createString(this.addressField!) : 0;
    const profileRow = this.profileRow !== null ? builder.createString(this.profileRow!) : 0;

    return Entry.createEntry(
      builder,
      this.key !== null ? this.key!.pack(builder) : 0,
      name,
      dataType,
      parentCategory,
      this.arrayLen,
      arrayLenExpr,
      this.expansion,
      addedVersion,
      this.obsolete,
      this.notImplemented,
      this.source,
      this.includeIndex,
      this.line,
      this.decodeType,
      decode,
      this.ruleType,
      rule,
      this.address,
      addressField,
      this.origin,
      profileRow,
    );
  }

  clone(): EntryT {
    const obj = new EntryT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.name = this.name;
    obj.dataType = this.dataType;
    obj.parentCategory = this.parentCategory;
    obj.arrayLen = this.arrayLen;
    obj.arrayLenExpr = this.arrayLenExpr;
    obj.expansion = this.expansion;
    obj.addedVersion = this.addedVersion;
    obj.obsolete = this.obsolete;
    obj.notImplemented = this.notImplemented;
    obj.source = this.source;
    obj.includeIndex = this.includeIndex;
    obj.line = this.line;
    obj.decodeType = this.decodeType;
    obj.decode =
      this.decode !== null && typeof (this.decode as any).clone === "function"
        ? (this.decode as any).clone()
        : this.decode;
    obj.ruleType = this.ruleType;
    obj.rule =
      this.rule !== null && typeof (this.rule as any).clone === "function"
        ? (this.rule as any).clone()
        : this.rule;
    obj.address = this.address;
    obj.addressField = this.addressField;
    obj.origin = this.origin;
    obj.profileRow = this.profileRow;
    return obj;
  }

  equals(other: EntryT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.name !== other.name) return false;
    if (this.dataType !== other.dataType) return false;
    if (this.parentCategory !== other.parentCategory) return false;
    if (this.arrayLen !== other.arrayLen) return false;
    if (this.arrayLenExpr !== other.arrayLenExpr) return false;
    if (this.expansion !== other.expansion) return false;
    if (this.addedVersion !== other.addedVersion) return false;
    if (this.obsolete !== other.obsolete) return false;
    if (this.notImplemented !== other.notImplemented) return false;
    if (this.source !== other.source) return false;
    if (this.includeIndex !== other.includeIndex) return false;
    if (this.line !== other.line) return false;
    if (this.decodeType !== other.decodeType) return false;
    if (this.decode !== null && other.decode !== null) {
      if (typeof (this.decode as any).equals === "function") {
        if (!(this.decode as any).equals(other.decode)) return false;
      } else if (this.decode !== other.decode) return false;
    } else if (this.decode !== other.decode) return false;
    if (this.ruleType !== other.ruleType) return false;
    if (this.rule !== null && other.rule !== null) {
      if (typeof (this.rule as any).equals === "function") {
        if (!(this.rule as any).equals(other.rule)) return false;
      } else if (this.rule !== other.rule) return false;
    } else if (this.rule !== other.rule) return false;
    if (this.address !== other.address) return false;
    if (this.addressField !== other.addressField) return false;
    if (this.origin !== other.origin) return false;
    if (this.profileRow !== other.profileRow) return false;
    return true;
  }
}

export function verifyEntry(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 12);
    verifier.checkRequiredField(tablePos, 4, "key");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "name");
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 8, "data_type");
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 12, 2);
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 16, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 18);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 20, 1);
    verifier.checkScalarField(tablePos, 22, 1);
    verifier.checkScalarField(tablePos, 24, 1);
    verifier.checkScalarField(tablePos, 26, 2);
    verifier.checkScalarField(tablePos, 28, 4);
    verifier.checkScalarField(tablePos, 30, 1);
    verifier.checkUnionConsistency(tablePos, 30, 32, "decode");
    {
      const pos = verifier.checkOffsetField(tablePos, 32);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 30);
        switch (uType) {
          case 1: // ScalarDecode
            {
              const o = verifier.readInt32(pos);
              verifyScalarDecode(verifier, pos + o);
            }
            break;
          case 2: // StructDecode
            {
              const o = verifier.readInt32(pos);
              verifyStructDecode(verifier, pos + o);
            }
            break;
          case 3: // TextDecode
            {
              const o = verifier.readInt32(pos);
              verifyTextDecode(verifier, pos + o);
            }
            break;
          case 4: // TransformDecode
            {
              const o = verifier.readInt32(pos);
              verifyTransformDecode(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkScalarField(tablePos, 34, 1);
    verifier.checkUnionConsistency(tablePos, 34, 36, "rule");
    {
      const pos = verifier.checkOffsetField(tablePos, 36);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 34);
        switch (uType) {
          case 1: // IgnoreRule
            {
              const o = verifier.readInt32(pos);
              verifyIgnoreRule(verifier, pos + o);
            }
            break;
          case 2: // FlagRule
            {
              const o = verifier.readInt32(pos);
              verifyFlagRule(verifier, pos + o);
            }
            break;
          case 3: // ValuedRule
            {
              const o = verifier.readInt32(pos);
              verifyValuedRule(verifier, pos + o);
            }
            break;
          case 4: // EnumMapRule
            {
              const o = verifier.readInt32(pos);
              verifyEnumMapRule(verifier, pos + o);
            }
            break;
          case 5: // RecordRule
            {
              const o = verifier.readInt32(pos);
              verifyRecordRule(verifier, pos + o);
            }
            break;
          case 6: // TransformRule
            {
              const o = verifier.readInt32(pos);
              verifyTransformRule(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 36, "rule");
    verifier.checkScalarField(tablePos, 38, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 40);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkScalarField(tablePos, 42, 1);
    {
      const pos = verifier.checkOffsetField(tablePos, 44);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
